// Module
var code = "<input class=form-control ng-disabled=ngDisabled name=nlgIntlPhoneNumber type=tel ng-model=model ng-blur=format() ng-intl-tel-input data-default-country={{::defaultCountry}} data-selected-country=countryData />";
// Exports
module.exports = code;